const t = {
  name: "SearchList",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 3V5H22V3H2Z" fill="currentColor"/>
<path d="M2 8H9V10H2V8Z" fill="currentColor"/>
<path d="M7 13H2V15H7V13Z" fill="currentColor"/>
<path d="M9 14C9 10.6863 11.6863 8 15 8C18.3137 8 21 10.6863 21 14C21 15.2958 20.5892 16.4957 19.8907 17.4765L22.4142 20L21 21.4142L18.4765 18.8907C17.4957 19.5892 16.2958 20 15 20C11.6863 20 9 17.3137 9 14ZM15 10C12.7909 10 11 11.7909 11 14C11 16.2091 12.7909 18 15 18C17.2091 18 19 16.2091 19 14C19 11.7909 17.2091 10 15 10Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as SearchList
};
